import { Ba1111Class } from './ba1111-class';
import { Ba1112Class } from './ba1112-class';
import { Ba1113Class } from './ba1113-class';

export class Ba1110Class {
    UserId:number;
    UserNam:string;
    UserLgnPwd:string;
    UserTrnPwd:string;
    FkFieldIdUserGroup:number;
    FkFieldIdUserType:number;
    FkEmpId:number;
    ValidUpTo:Date;
    PortalUser:number;
    FkRoleId:number;
    ExternalUserName:string;
    Remarks:string;
    FkFieldIdUserTypeDescr:string;
    FkFieldIdUserGroupDescr:string;
    EmployeeName:string;
    FkFkEmpIdDiv:string;
    ExternalUserNameDiv:string;
    Confirm:string;
    ConfirmTran:string;
    Active:number;
    FkCompId:number;
    Ba1111List: Array<Ba1111Class> = [];
    FkBranchId:number;
    Ba1110List: Array<Ba1110Class> = [];

    Ba1112List: Array<Ba1112Class> = [];
    Ba1113List: Array<Ba1113Class> = [];

    ba1110History:Ba1110Class;
    MdfdBy: number;
    MdfdOn: Date;
    FkCompIdForEmployee:number;
    StrCompanyName:string ;
    StrEmployeeCode:string;
    StrEmployeeName:string;
    StrValidDate:string;
    StrDefaultCompany:string;
  
}
